import {
  IChangeOrderStatusDTO,
  IGetOrdersDTO,
  IGetOrdersResponse,
  staticOrderEndpoints,
  TChangeOrderStatusResponse,
  IGetOrderResponse,
  getOrdersEndpoints,
  IDeleteFilesDTO,
  IUploadFilesDTO,
  TDeleteFilesResponse,
  TUploadFilesResponse,
  ICompleteOrderDTO,
  TCompleteOrderResponse,
  IUpdateAppraisalOrderDTO,
} from '@/models/order.model';
import { ApiResponse, httpClient } from '@/utils';

class OrderAPI {
  static getOrders(data: IGetOrdersDTO): ApiResponse<IGetOrdersResponse> {
    const { GET_ORDERS } = staticOrderEndpoints;
    return httpClient.get<IGetOrdersResponse>(GET_ORDERS, { params: data });
  }

  static getOrder(id: string): ApiResponse<IGetOrderResponse> {
    const { GET_ORDER } = getOrdersEndpoints({ orderId: id });
    return httpClient.get<IGetOrderResponse>(GET_ORDER);
  }

  static changeOrderStatus({ id, ...data }: IChangeOrderStatusDTO): ApiResponse<TChangeOrderStatusResponse> {
    const { CHANGE_STATUS } = getOrdersEndpoints({ orderId: id });
    return httpClient.post<TChangeOrderStatusResponse>(CHANGE_STATUS, data);
  }

  static completeOrder({ id }: ICompleteOrderDTO): ApiResponse<TCompleteOrderResponse> {
    const { COMPLETE_ORDER } = getOrdersEndpoints({ orderId: id });
    return httpClient.post<TCompleteOrderResponse>(COMPLETE_ORDER);
  }

  static updateAppraiserOrder({ id, ...data }: IUpdateAppraisalOrderDTO): ApiResponse<IGetOrderResponse> {
    const { UPDATE_APPRAISAL_ORDER } = getOrdersEndpoints({ orderId: id });
    return httpClient.post<IGetOrderResponse>(UPDATE_APPRAISAL_ORDER, data);
  }

  static uploadOrderFiles({ orderId, ...data }: IUploadFilesDTO): ApiResponse<TUploadFilesResponse> {
    const { UPLOAD_FILES } = getOrdersEndpoints({ orderId });
    return httpClient.post<TUploadFilesResponse>(UPLOAD_FILES, data);
  }

  static deleteOrderFiles(data: IDeleteFilesDTO): ApiResponse<TDeleteFilesResponse> {
    const { DELETE_FILES } = getOrdersEndpoints(data);
    return httpClient.delete<TDeleteFilesResponse>(DELETE_FILES);
  }
}

export default OrderAPI;
